import React from 'react';
import { BrowserRouter as Router, Switch } from 'react-router-dom';
import Route from './Layout';

import Begin from '../pages/Begin';
import VoluntaryReturn from '../pages/VoluntaryReturn';
import Finish from '../pages/Finish';
import ReservationReport from 'src/pages/ReservationReport';
import Vaccination from 'src/pages/Vaccination';
import PermissionRoute from 'src/components/Permission/Route';
import Login from 'src/pages/Login';
import Fleets from 'src/pages/Fleets';
import Vehicles from 'src/pages/Vehicles';
import Collaborators from 'src/pages/Collaborators';
import enRoles from 'src/models/enums/enRoles';

const routes: React.FC = () => {
  return (
    <Router>
      <Switch>
        <Route exact path='/'>
          <Begin />
        </Route>
        <Route path='/cadastro'>
          <VoluntaryReturn />
        </Route>
        <Route path='/concluido'>
          <Finish />
        </Route>
        <Route path='/login'>
          <Login />
        </Route>
        <Route path='/relatorio-reserva'>
          <PermissionRoute component={ReservationReport} roles={[enRoles.admin, enRoles.sysAdmin, enRoles.doctor]} />
        </Route>
        <Route path='/vacinacao'>
          <PermissionRoute component={Vaccination} roles={[enRoles.admin, enRoles.sysAdmin, enRoles.doctor]} />
        </Route>
        <Route path='/frotas'>
          <PermissionRoute component={Fleets} roles={[enRoles.admin, enRoles.sysAdmin, enRoles.doctor]} />
        </Route>
        <Route path='/veiculos'>
          <PermissionRoute component={Vehicles} roles={[enRoles.admin, enRoles.sysAdmin, enRoles.doctor]} />
        </Route>
        <Route path='/colaboradores'>
          <PermissionRoute component={Collaborators} roles={[enRoles.admin, enRoles.sysAdmin, enRoles.doctor]} />
        </Route>
      </Switch>
    </Router>
  );
};

export default routes;
